import moment from "moment";
import { IAppointmentEvent } from "../../helpers/Interfaces";
import Modal from "../Modal/Modal";
import { useContext, useState } from "react";
import { AppointmentReport } from "../../store/Store";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/ApiService";
import DeletePrompt from "../DeletePrompt/DeletePrompt";
import { splitWord } from "../../helpers/HelperFunctions";

import "./AppointmentModal.scss"

function AppointmentModal(props: {
    open: boolean;
    closeModal: (modal: "add" | "edit" | "view", shouldUpdate: boolean) => void;
    selectedAppointment: IAppointmentEvent
    openModal: (modal: "add" | "edit" | "view") => void;
}) {
    const navigate = useNavigate();
    const { changeAppointmentReport } = useContext(AppointmentReport);

    const apiService = new ApiService();
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState({ isError: false, message: "", open: false });
    const [deelteAlert, setDeleteAlert] = useState(false);

    const handleOpenEdit = () => {
        props.openModal("edit")
        props.closeModal("view", false)
    };

    const handleCloseView = (update = false) => {
        props.closeModal("view", update)
    };

    function getInvoiceStatus(invoiceStatus: string | undefined) {
        if (!invoiceStatus) {
            return null;
        }

        if (invoiceStatus === "Created") {
            return 1;
        } else if (invoiceStatus === "Sent") {
            return 2;
        }

        return 0;
    }

    const createReport = () => {
        changeAppointmentReport({
            clinicName: props.selectedAppointment.clinicName,
            patientName: props.selectedAppointment.patientName,
            dateOfAssessment: props.selectedAppointment.startTime,
            appointmentId: props.selectedAppointment.appointmentId,
            notes: props.selectedAppointment.notes,
            paperworkReceived: props.selectedAppointment.paperworkReceived,
            invoiceStatus: getInvoiceStatus(props.selectedAppointment.invoiceStatus),
            referrerId: props.selectedAppointment.referrerId
        });

        handleCloseView();
        navigate("/dashboard/reports");
    }

    const viewReport = () => {
        handleCloseView();
        navigate(`/dashboard/reports/${props.selectedAppointment.documentId}`)
    }

    const closeAlert = () => {
        let newShowAlert = showAlert;
        newShowAlert.open = false;
        setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
    }

    function deleteAppointment() {

        setLoading(true);

        apiService.deleteAppointment(props.selectedAppointment.appointmentId).then((result) => {

            let data = result.data;

            if (!data?.isSuccessful) {
                let newShowAlert = showAlert;
                newShowAlert.isError = true;
                newShowAlert.message = data?.errorMessage;
                newShowAlert.open = true;
                setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
                return;
            }

            let newShowAlert = showAlert;
            newShowAlert.isError = false;
            newShowAlert.message = "Appointment Added";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));

            handleCloseView(true);
        }).catch(() => {
            let newShowAlert = showAlert;
            newShowAlert.isError = true;
            newShowAlert.message = "Unexpected Error";
            newShowAlert.open = true;
            setShowAlert((prevDetails) => ({ ...prevDetails, ...newShowAlert }));
        }).finally(() => {
            setLoading(false);
        });
    }

    function checkDocument() {
        if (props.selectedAppointment.documentId != null) {
            return true
        }
        return false
    }

    return (
        <Modal editable={true} openEdit={handleOpenEdit} open={props.open}
            close={() => handleCloseView()} style={"appointment-card-modal"} >
            <div className="appointment-card-container">
                <div className="header">
                    <span className="title">
                        {`${props.selectedAppointment.patientName} ${props.selectedAppointment.referrer ? (props.selectedAppointment.referrer) : ("")}`}
                    </span>
                </div>
                <div className="body">
                    <div className="row">
                        <span className="name">{props.selectedAppointment.clinicName}</span>
                        <span className="date">
                            {moment(props.selectedAppointment.startTime).format("hh:mm A, DD-MM-YYYY")}
                        </span>
                    </div>
                    <span className="comments">{props.selectedAppointment.notes}</span>
                    <span className="attributes">{`Appointment: ${props.selectedAppointment.appointmentStatus}`}</span>
                    <span className="attributes">{`Paperwork Received: ${props.selectedAppointment.paperworkReceived ? "Yes" : "No"}`}</span>
                    {props.selectedAppointment.consultationMode
                        ? (
                            <span className="attributes">
                                {`Consultation: ${splitWord(props.selectedAppointment.consultationMode)}`}
                            </span>
                        )
                        : (<></>)
                    }
                    {props.selectedAppointment.invoiceStatus
                        ? (<span className="attributes">{`Invoice: ${splitWord(props.selectedAppointment.invoiceStatus)}`}</span>)
                        : (<></>)
                    }
                </div>
                <div className="footer">
                    <button className="create-report delete-report" onClick={() => setDeleteAlert(true)}>Delete</button>
                    <DeletePrompt loading={loading} close={() => { setDeleteAlert(false); }}
                        open={deelteAlert} header={"Delete Appointment for " + props.selectedAppointment.patientName + "?"}
                        onDelete={deleteAppointment} showAlert={showAlert} closeAlert={closeAlert}
                        body={"This will remove all associated data related to this appointment. " +
                            "Are you certain you wish to proceed with this operation?"} />
                    <div>
                        {checkDocument()
                            ? (<button className="create-report" onClick={viewReport}>
                                View Details
                            </button>)
                            : (<button className="create-report" onClick={createReport}>
                                Create Report
                            </button>)
                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default AppointmentModal